<script>
import DataTableRequestColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableRequestColumn.vue';
import ClientRequest from '@/app/client/ClientRequest';

export default {
  name: 'GroupRazaoSocialColumn',
  extends: DataTableRequestColumnVue,
  data: () => ({
    requestClass: ClientRequest,
    defaultPropertyName: 'nomRazaoSocial',
  }),
};
</script>
